export default "assets/images/logo-dark-89519cbc.svg";